export const formatSize = size => {
  return size.join(', ');
};

export const formatColors = colors => {
  return colors.join(', ');
};
